import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
  Divider,
  Card,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentsIcon from "@mui/icons-material/Payments";
import ImageIcon from "@mui/icons-material/Image";
import PersonalDetails from "./PersonalDetails";
import AccountDetails from "./AccountDetails";
import CompensationDetails from "./CompensationDetails";
import ImageDetails from "./ImageDetails";
import { useSelector } from "react-redux";
import LeaveBalanceForm from "./LeaveBalance"; // Import the LeaveBalanceForm component








// ==========================================
// 2. MAIN DIALOG COMPONENT (RESPONSIVE)
// ==========================================
const MultiPageDialog = ({ open, handleClose, id }) => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  
  // Mobile devices ke liye dialog fullScreen ho jayega automatic
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const { company_id, is_super, is_admin, permissions } = useSelector(
          (state) => state.GlobalVariables
      );

  // Switch wrapper rendering pages based on index
  const renderPageContent = (index) => {
    switch (index) {
      case 0:
        return <PersonalDetails companyId={company_id} employeeId={id} />;
      case 1:
        return <AccountDetails companyId={company_id} employeeId={id} />;
      case 2:
        return <CompensationDetails employeeId={id} companyId={company_id} />;
      case 3:
        return <ImageDetails employeeId={id} />;
      case 4:
        return <LeaveBalanceForm employeeId={id} companyId={company_id} />;
      default:
        return <PersonalDetails />;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={isMobile} // Mobile screen par fullscreen fit layout
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : "20px",
          bgcolor: "#f8fafc", // Clean Slate White Premium BG
          minHeight: isMobile ? "100vh" : "550px",
        },
      }}
    >
      {/* DIALOG HEADER */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#fff",
        }}
      >
        <Typography variant="h6" fontWeight="700" color="#1e293b">
          User Master Configuration
        </Typography>
        <IconButton onClick={handleClose} sx={{ color: "#64748b" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* HEADER TABS MENU (SCROLLABLE & RESPONSIVE) */}
      <Box sx={{ width: "100%", bgcolor: "#fff", borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "fullWidth"} // Mobile pe automatically scrollable menu ban jayega
          scrollButtons="auto"
          allowScrollButtonsMobile
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "600",
              fontSize: { xs: "13px", sm: "14px" },
              py: 1.5,
              minWidth: { xs: "120px", sm: "auto" }
            },
          }}
        >
          <Tab icon={<PersonIcon fontSize="small" />} iconPosition="start" label="Personal" />
          <Tab icon={<AccountBalanceIcon fontSize="small" />} iconPosition="start" label="Account" />
          <Tab icon={<PaymentsIcon fontSize="small" />} iconPosition="start" label="Compensation" />
          <Tab icon={<ImageIcon fontSize="small" />} iconPosition="start" label="Images" />
          <Tab icon={<CalendarTodayIcon fontSize="small" />} iconPosition="start" label="Leave Balance" />
        </Tabs>
      </Box>

      {/* RENDER DYNAMIC PAGES */}
      <DialogContent sx={{ p: 3, bgcolor: "#f8fafc" }}>
        <Card sx={{ borderRadius: "16px", p: { xs: 2, sm: 3 }, boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
          {renderPageContent(activeTab)}
        </Card>
      </DialogContent>

      <Divider />

      {/* BOTTOM WIZARD CONTROLS */}
      <DialogActions sx={{ p: 2, bgcolor: "#fff" }}>
        <Button
          disabled={activeTab === 0}
          onClick={() => setActiveTab((prev) => prev - 1)}
          sx={{ textTransform: "none", fontWeight: "600", borderRadius: "8px" }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        {activeTab < 4 ? (
          <Button
            variant="contained"
            onClick={() => setActiveTab((prev) => prev + 1)}
            sx={{ textTransform: "none", fontWeight: "600", borderRadius: "8px", px: 3 }}
          >
            Next
          </Button>
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={handleClose}
            sx={{ textTransform: "none", fontWeight: "600", borderRadius: "8px", px: 3 }}
          >
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MultiPageDialog;